"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedErrorMessage = exports.logCritical = exports.logError = exports.logWarning = exports.logInfo = exports.logStd = exports.logger = exports.getLogFormattedMessage = exports.LogTypes = void 0;
const isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
var LogTypes;
(function (LogTypes) {
    LogTypes["log"] = "log";
    LogTypes["info"] = "info";
    LogTypes["warn"] = "warn";
    LogTypes["error"] = "error";
    LogTypes["critical"] = "critical";
})(LogTypes = exports.LogTypes || (exports.LogTypes = {}));
const getLogFormattedMessage = (logType = LogTypes.log, serviceName = null, correlationId = null, ...args) => {
    const firstArgs = [logType, serviceName, correlationId];
    const uuidIndex = firstArgs.findIndex((item) => isUuid.test(item));
    const functionArgs = uuidIndex === -1 ? [correlationId, ...args] : [...args];
    const uuid = uuidIndex > -1 ? firstArgs[uuidIndex] : null;
    let message = `${logType.toUpperCase()}: ${serviceName && !isUuid.test(serviceName) ? `Service name: ${serviceName} - ` : ''}${uuid ? `Correlation Id: ${uuid} -` : ''}`;
    functionArgs.forEach((arg) => {
        switch (typeof arg) {
            case 'object':
                message += ` \`${JSON.stringify(arg)}\``;
                break;
            case 'string':
            default:
                message += ` ${arg}`;
                break;
        }
    });
    return message;
};
exports.getLogFormattedMessage = getLogFormattedMessage;
const logger = (logType = LogTypes.log, serviceName = null, correlationId = null, ...args) => {
    const message = (0, exports.getLogFormattedMessage)(logType, serviceName, correlationId, ...args);
    switch (logType) {
        case LogTypes.critical:
        case LogTypes.error:
            console.error(message);
            break;
        case LogTypes.info:
            console.info(message);
            break;
        case LogTypes.warn:
            console.warn(message);
            break;
        case LogTypes.log:
        default:
            console.log(message);
            break;
    }
    return message;
};
exports.logger = logger;
const logStd = (serviceName, correlationId, ...args) => {
    return (0, exports.logger)(LogTypes.log, serviceName, correlationId, ...args);
};
exports.logStd = logStd;
const logInfo = (serviceName, correlationId, ...args) => {
    return (0, exports.logger)(LogTypes.info, serviceName, correlationId, ...args);
};
exports.logInfo = logInfo;
const logWarning = (serviceName, correlationId, ...args) => {
    return (0, exports.logger)(LogTypes.warn, serviceName, correlationId, ...args);
};
exports.logWarning = logWarning;
const logError = (serviceName, correlationId, ...args) => {
    return (0, exports.logger)(LogTypes.error, serviceName, correlationId, ...args);
};
exports.logError = logError;
const logCritical = (serviceName, correlationId, ...args) => {
    return (0, exports.logger)(LogTypes.critical, serviceName, correlationId, ...args);
};
exports.logCritical = logCritical;
const getFormattedErrorMessage = (serviceName, error, functionName = null) => {
    const errorMessage = `${functionName ? `${functionName}(): ` : ''}${(error === null || error === void 0 ? void 0 : error.message) || 'No error message found on the error'}`;
    (0, exports.logError)(serviceName, errorMessage);
    return errorMessage;
};
exports.getFormattedErrorMessage = getFormattedErrorMessage;
//# sourceMappingURL=logs.js.map